(function (window, document) {
  function validateEmail(v) {
    return !!v && /^\S+@\S+$/.test(v);
  }

  const input = $(".signup-section-outer input#input-email");

  function signupRequest(email) {
    const status = validateEmail(email);
    if (status) {
      const url =
        "https://76af9h1lq2.execute-api.us-east-2.amazonaws.com/v1/MailchimpHandler?email=" +
        email;
      $.get(url, function (response) {
        console.log("success", response);
        $("#signup-form").hide();
        $("#signup-success").show();
        $("#email-success-registered").text(email);
      }).fail(function (error) {
        if (error && error.responseText) {
          const message = error.responseText.message;
        }
      });
    }
  }

  input.on("change paste keyup", function () {
    const email = $(this).val();
    const status = validateEmail(email);

    console.log(email);

    if (email === "") {
      $(".signup-section-outer .arrow")
        .removeClass("ok")
        .removeClass("incorrect");
      return;
    }

    if (status) {
      $(".signup-section-outer .arrow").removeClass("incorrect").addClass("ok");
    } else {
      $(".signup-section-outer .arrow").removeClass("ok").addClass("incorrect");
    }
  });

  input.on("keyup", function (data) {
    if (data.which === 13) {
      const email = $(this).val();
      signupRequest(email);
    }
  });

  $(".signup-form .arrow").on("click", function (data) {
    const email = $(input).val();
    signupRequest(email);
  });
})(window, document);
